module.exports = __webpack_public_path__ + "static/media/section3.e9fefd6c.png";